/**
 * @author        patrick@zumper.com (Patrick Giddings)
 * @copyright     Copyright (c) 2023, Zumper
 * @description   thunk for dispatching optimizely user engagement events from traktor events
 */

import type { ExtraThunkArg } from '@zcode/state-type'
import { logger } from '../logger'
import { TRAKTOR_EVENT_TO_OPTIMIZELY_EVENTS } from './traktorEventMappings.constants'

export const trackOptimizelyTraktorEvents =
  (name: string, props: object | undefined) =>
  (_: unknown, __: unknown, { optimizely }: Pick<ExtraThunkArg, 'optimizely'>) => {
    if (optimizely) {
      const optimizelyEvent = TRAKTOR_EVENT_TO_OPTIMIZELY_EVENTS[name]
      if (optimizelyEvent) {
        // @ts-expect-error optimizely's types say it wants props to be
        // Readonly<Record<string, string | number | null>> | undefined
        //
        // But if we pass them something like
        // {someBoolean: false, nested: { text: "like this" } }
        // their client passes it along to their backend without complaint at runtime
        // (and we sometimes pass nested objects like that to traktor, so that's why
        // we can't use the type Optimizely wants here)
        optimizely.track(optimizelyEvent, props)
      }
    } else {
      logger.warn(
        'trackOptimizelyTraktorEvent called but optimizely was not provided in ExtraThunkArg'
      )
    }
  }
